import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { StageStats } from '../../types/types';
import LoadingSpinner from '../common/LoadingSpinner'

interface StageSummaryProps {
    stages: StageStats[];
    isLoading: boolean;
}

const StageSummary: React.FC<StageSummaryProps> = ({ stages, isLoading }) => {
    // Colors for different stages
    const getColorForStage = (stageIndex: number): string => {
        const colors = ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'dark'];
        return colors[stageIndex % colors.length];
    };

    if (isLoading) {
        return (
            <LoadingSpinner centered />
        );
    }

    if (!stages || stages.length === 0) {
        return (
            <div className="text-center p-5">
                <p className="text-muted mb-0">No stage data available</p>
            </div>
        );
    }

    // Sort stages by display order if available, otherwise alphabetically
    const sortedStages = [...stages].sort((a, b) => {
        if (a.displayOrder !== undefined && b.displayOrder !== undefined) {
            return a.displayOrder - b.displayOrder;
        }
        return a.stageName.localeCompare(b.stageName);
    });

    return (
        <Row className="g-3">
            {sortedStages.map((stage, index) => (
                <Col key={stage.stageId} xs={6} sm={4} md={3} lg={2}>
                    <Card
                        className="mb-3 h-100 border-0 shadow-sm"
                        as={Link}
                        to={`/candidates/stage/${stage.stageId}`}
                        style={{
                            textDecoration: 'none',
                            color: 'inherit',
                            transition: 'transform 0.2s',
                        }}
                        onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
                        onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                    >
                        <Card.Body className="d-flex flex-column align-items-center p-0">
                            <h3 className={`display-6 fw-bold text-${getColorForStage(index)}`}>{stage.count}</h3>
                            <Card.Title className="text-center mb-0 h6">{stage.stageName}</Card.Title>
                        </Card.Body>
                    </Card>
                </Col>
            ))}
        </Row>
    );
};

export default StageSummary;